var map = {
	"./Budgetbewust.png": 2257,
	"./Fijn-proever.png": 6165,
	"./Gezondheidsbewuste.png": 1827,
	"./Local-Lover.png": 3638,
	"./Luxezoeker.png": 1536,
	"./Milieubewuste.png": 6554,
	"./Traditionalist.png": 3682,
	"./Trendvolger.png": 1368,
	"./check.png": 1378,
	"./chilly-willy.png": 4521,
	"./close.png": 8270,
	"./sleepy-willy.png": 3116,
	"./stern-willy.png": 2046,
	"Images/presets/Budgetbewust.png": 2257,
	"Images/presets/Fijn-proever.png": 6165,
	"Images/presets/Gezondheidsbewuste.png": 1827,
	"Images/presets/Local-Lover.png": 3638,
	"Images/presets/Luxezoeker.png": 1536,
	"Images/presets/Milieubewuste.png": 6554,
	"Images/presets/Traditionalist.png": 3682,
	"Images/presets/Trendvolger.png": 1368,
	"Images/presets/check.png": 1378,
	"Images/presets/chilly-willy.png": 4521,
	"Images/presets/close.png": 8270,
	"Images/presets/sleepy-willy.png": 3116,
	"Images/presets/stern-willy.png": 2046
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8708;